import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import Modal from "react-bootstrap/Modal";
import ReactStars from "react-rating-stars-component";
import { ToastContainer, toast } from 'react-toastify';
import { Bar } from 'react-chartjs-2';
import { Pie } from 'react-chartjs-2';
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
    Chart as ChartJS,
    CategoryScale,
    ArcElement,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import * as faker from 'faker';
import { useMutation, useQuery } from "@apollo/client";
import { Get_test, View_Ranker } from "../../gql/queries";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import moment from "moment";
import { testPerformanceTest, transform } from "../../utils";
import { firebaseData } from "../../firebase";
import { Star_Bookmark } from "../../gql/mutation";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import NoDataFound from "../common/NoDataFound/NoDataFound";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import { decrypt } from "../../utils/crypto";
import ConnectionError from "../common/NoDataFound/ConnectionError";
ChartJS.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
const INITIAL_STATE = {
    feedback: "",
}
ChartJS.register(ChartDataLabels);
export default function TestPerformance() {
    const currentPageUrl = window.location.href;
    const location = useLocation();
    let { id } = useParams()
    const navigate = useNavigate()
    const [config, setConfig] = useState();
    const [remoteLoading, setRemoteLoading] = useState(true);
    const [status, setStatus] = useState('mark');
    const [mydata, setMydata] = useState(0);
    const [average, setAverage] = useState(0);
    const [topper, setTopper] = useState(0);
    const [open, setOpen] = useState(0);
    const [rating, setRating] = useState(false);
    const [getDetails, Details] = useState(INITIAL_STATE);
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const [star, setData] = useState(0);
    const showRating = () => setRating(true);
    const hideRating = () => setRating(false);
    const [ranker, setRanker] = useState()
    const showRanker = () => setRanker(true);
    const hideRanker = () => setRanker(false);


    const query1 = useQuery(Get_test, {
        variables: {
            "_id": id,
        },
    });

    useEffect(() => {
        // Push initial state
        window.history.pushState(null, null, window.location.href);

        const handlePopState = () => {
            navigate('/testlayer');
            // Push the state again to maintain the history
            window.history.pushState(null, null, window.location.href);
        };

        // Set the popstate event listener
        window.addEventListener('popstate', handlePopState);

        return () => {
            // Clean up the event listener on unmount
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate]);
    const query3 = useQuery(View_Ranker, {
        variables: {
            "qbId": id,
            "page": 1,
            "perPage": 30
        },
    });
    console.log(query3.data, "ranker data");
    const [getBookmark] = useMutation(Star_Bookmark, {
        refetchQueries: [
            {
                query: Get_test,
                variables: {
                    "_id": id,
                },
            }, // DocumentNode object parsed with gql
            'testdetails' // Query name,

        ],
    });

    const rankersIncorrectData = (question) => {
        const result = question.filter((data) => data.isCorrect === false);
        return result.length
    }
    const rankersCorrectData = (question) => {
        const result = question.filter((data) => data.isCorrect === true);
        return result.length
    }


    useEffect(() => {
        const getConfigData = async () => {
            try {
                const remoteData = await firebaseData('performance_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setConfig(JSON.parse(remoteData));
                setRemoteLoading(false);
                query1.refetch({ '_id': id })
            } catch (error) {
                console.error('Error fetching remote data:', error);
                setRemoteLoading(false);
            }
        };

        if (typeof window !== 'undefined') {
            getConfigData();
        }
    }, []);

    if (query1.loading) return (<><Loader /></>)
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            authorizationCheck(navigate)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        console.log(query1.error)
    }

    const options = {
        responsive: true,
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: 20,
                bottom: 0
            }
        },
        plugins: {
            datalabels: {
                display: true,
                color: "#27387D",
                anchor: "end",
                offset: -32,
                align: "start",
                // padding: {
                //   right: 0
                // },
                labels: {
                    padding: { top: 0 },
                    title: {
                        font: {
                            weight: "bold"
                        }
                    },
                    //   value: {
                    //     color: "green"
                    //   }
                },
                formatter: function (value) {
                    //return "\n" + Math.floor(value);                    
                    return "\n" + value.toFixed(2);
                }
            },
            legend: {
                display: false,
                position: 'top',
            },
            title: {
                display: false,
                text: 'Chart.js Bar Chart',
            },
        },
        scales: {
            x: {
                display: true,        // show/ hide x-axis
                grid: {
                    display: false      // show/hide grid line in x-axis
                },
            },
            y: {
                min: 0,
                max: status === 'mark' ? query1?.data?.test && query1?.data?.test?.progress?.totalMarks : 100,
                display: true,
                ticks: {
                    stepSize: 10
                },      // same as x-axis
                grid: {
                    display: true
                },
            }
        }
    };
    const labels = ['You', 'Topper', 'Average'];
    const graphData = (detail1, detail2, detail3, detail) => {
        setMydata(detail1)
        setAverage(detail2)
        setTopper(detail3)
        setStatus(detail)
    }
    const data = {
        labels: ["You", "Topper", "Average"],
        datasets: [
            //   {
            //     // label: 'Dataset 1',
            //     data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
            //     // backgroundColor: 'rgba(255, 99, 132, 0.5)',
            //   },
            {
                labels: ["You", "Topper", "Average"],
                // data: [mydata > 0 ? mydata : (query1.data && (query1?.data?.test && query1?.data?.test?.progress?.marks) > 0 ? query1?.data?.test && (query1?.data?.test?.progress?.marks) : 0), topper > 0 ? topper : (query1.data.test.resultData && (query1.data.test.resultData.topperMarks) > 0 ? query1.data.test.resultData && (query1.data.test.resultData.topperMarks) : 0), average ? average : query1.data.test.resultData && (query1.data.test.resultData.avgMarks)],
                data: [mydata > 0 ? mydata : (query1.data && (query1?.data?.test && query1?.data?.test?.progress?.marks) > 0 ? query1?.data?.test && (query1?.data?.test?.progress?.marks) : 0), topper > 0 ? topper : (query1.data.test.resultData && (query1.data.test.resultData.topperMarks) > 0 ? query1.data.test.resultData && (query1.data.test.resultData.topperMarks) : 0), average ? average : 0],
                backgroundColor: '#7C88B0',
                borderRadius: '12',
                barThickness: 60,
            },
        ],
    };

    const pieoptions = {
        responsive: true,
        plugins: {
            datalabels: {
                display: false,
                color: "#27387D",
                anchor: "end",
                offset: -32,
                align: "start",
                // padding: {
                //   right: 0
                // },
                labels: {
                    padding: { top: 0 },
                    title: {
                        font: {
                            weight: "bold"
                        }
                    },
                    //   value: {
                    //     color: "green"
                    //   }
                },
                formatter: function (value) {
                    return "\n" + Math.round(value);
                }
            },
            legend: {
                display: false,
                position: 'top',
            },
            title: {
                display: false,
                text: 'Chart.js Bar Chart',
            },
        },
    };

    const Piedata = {
        // labels: ['', ''],
        datasets: [
            {
                data: [query1.data.test.progress ? query1.data.test.progress.attemptedQuesCount : 0, ((query1.data.test ? query1.data.test.questions.length : 0) - (query1.data.test.progress ? query1.data.test.progress.attemptedQuesCount : 0))],
                backgroundColor: [
                    'rgba(4, 59, 92,1)',
                    'rgba(150, 200, 222, 1)',
                ],
                borderWidth: 0,
            },
        ],
    };
    const correctData = {
        // labels: ['', ''],
        datasets: [
            {
                data: [query1.data.test.progress ? query1.data.test.progress.correctQuestions : 0, ((query1.data.test ? query1.data.test.questions.length : 0) - (query1.data.test.progress ? query1.data.test.progress.correctQuestions : 0))],
                backgroundColor: [
                    'rgba(70, 184, 115, 1)',
                    'rgba(190, 222, 222, 1)',
                ],
                borderWidth: 0,
            },
        ],
    };
    const secondExample = {
        size: 20,
        count: 5,
        color: "#27387D",
        activeColor: "#ffd700",
        value: star,
        a11y: true,
        isHalf: false,
        emptyIcon: <i className="far fa-star" />,
        halfIcon: <i className="fa fa-star-half-alt" />,
        filledIcon: <i className="fa fa-star" />,
        onChange: newValue => {
            if (newValue <= 3) {
                setData(newValue)
                setRating(true)
            }
            else {
                setData(newValue)
                setRating(false)
                getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": true, rating: newValue, feedback: '' } })
            }
        }
    }

    const firstExample = {
        size: 20,
        count: 5,
        color: "#27387D",
        activeColor: "#ffd700",
        value: Math.floor(query1?.data?.test && query1?.data?.test?.progress?.rating),
        a11y: true,
        edit: false,
        isHalf: false,
        emptyIcon: <i className="far fa-star" />,
        halfIcon: <i className="fa fa-star-half-alt" />,
        filledIcon: <i className="fa fa-star" />,
        // onChange: newValue => {
        // }
    }

    const handleInputChange = function (fieldValue, fieldName) {
        Details({ ...getDetails, [fieldName]: fieldValue })
    }

    const submitBookmark = async (e) => {
        e.preventDefault();
        getBookmark({ variables: { resultId: query1.data.test.progress ? query1.data.test.progress._id : "", qbId: query1.data.test._id, resultType: "Test", questionId: "", subjectId: query1.data.test.subject, courseName: course.preparingFor, "status": true, rating: star, feedback: getDetails.feedback } }).then(res => {
            if (res.data.bookmarkQuestionOrQbTest) {
                toast.success('Thank you for your feedback');
                setRating(false)
                Details(INITIAL_STATE)
                setData(0)
            }
        }).catch(res => {
            const errors = res.graphQLErrors.map(err => err.message);
            console.log(errors)
        })
    }
    const incorrectData = {
        // labels: ['', ''],
        datasets: [
            {
                data: [query1.data.test.progress ? query1.data.test.progress.incorrectQuestions : 0, ((query1.data.test ? query1.data.test.questions.length : 0) - (query1.data.test.progress ? query1.data.test.progress.incorrectQuestions : 0))],
                backgroundColor: [
                    'rgba(220, 63, 22, 1)',
                    'rgba(255, 222, 222, 1)',
                ],
                borderWidth: 0,
            },
        ],
    };

    const unansweredData = {
        // labels: ['', ''],
        datasets: [
            {
                data: [query1.data.test.progress ? query1.data.test.progress.unattemptedQids.length : 0, ((query1.data.test ? query1.data.test.questions.length : 0) - (query1.data.test.progress ? query1.data.test.progress.unattemptedQids.length : 0))],
                backgroundColor: [
                    'rgba(156, 156, 156, 1)',
                    'rgba(241, 241, 241, 1)',
                ],
                borderWidth: 0,
            },
        ],
    };

    const guessData = {
        // labels: ['', ''],
        datasets: [
            {
                data: [query1.data.test.progress ? query1.data.test.progress.guessedCount : 0, ((query1.data.test ? query1.data.test.questions.length : 0) - (query1.data.test.progress ? query1.data.test.progress.guessedCount : 0))],
                backgroundColor: [
                    'rgba(205, 198, 165, 1)',
                    'rgba(245, 244, 237, 1)',
                ],
                borderWidth: 0,
            },
        ],
    };

    const reviewedData = {
        // labels: ['', ''],
        datasets: [
            {
                data: [query1.data.test.progress ? query1.data.test.progress.reviewedCount : 0, ((query1.data.test ? query1.data.test.questions.length : 0) - (query1.data.test.progress ? query1.data.test.progress.reviewedCount : 0))],
                backgroundColor: [
                    'rgba(255, 210, 40, 3)',
                    'rgba(255, 249, 230, 1)',
                ],
                borderWidth: 0,
            },
        ],
    };

    let exist = false
    let subjectExist = false
    let topicExist = true

    query1.data && query1?.data?.test?.progress?.subjectStats.map(obj => {
        if (obj?.subject === null || obj?.subject?.subjectId === null) {
            subjectExist = true
            return
        }
    })

    query1?.data && query1?.data?.test?.progress?.subjectStats?.map(on => {
        if ((on.topics?.some(item => item.topicId === null))) {
            topicExist = false
        }
    })

    const showSpentTime = () => {
        let spentTime = query1?.data?.test?.progress?.duration ? query1.data?.test?.progress?.duration / 60 : 0

        if (spentTime <= 60) {
            return `${parseInt(spentTime.toFixed(1))} mins`
        } else {
            const hours = Math.floor(spentTime / 60);
            const mins = spentTime % 60;
            return `${hours} Hr ${parseInt(mins.toFixed(1))} min`;
            //return `${(spentTime / 60).toFixed(1)} hours`
        }
        //  Math.round(((query1.data?.test?.progress?.duration) / 60).toFixed(1)) < query1.data.test.duration ? (((query1.data?.test?.progress?.duration) / 60).toFixed(1)) : query1.data.test.duration

    }


    // let tempArr = ['1', '2', 'd', '1']
    // console.log(new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime), "lllllllllllllllllllllllll");

    return (
        <>
            <div className="main_wrapper">
                <ToastContainer />
                <div className="breadcrumbs">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item"><a >Home</a></li>
                        <li className="breadcrumb-item"><a >Test</a></li>
                        <li className="breadcrumb-item"><a >Test Category</a></li>
                        <li className="breadcrumb-item"><a >{query1.data ? query1.data.test.title : ''}</a></li>
                        <li className="breadcrumb-item active"><a >Performance Summary</a></li>
                    </ul>
                </div>
                <section className="videoLayer_wrapper testPerformance_wrapper section_side_padding">
                    <div className='row'>
                        <div className="col-lg-8 col-md-7 col-sm-12">
                            <div className="subjects_wrapper">
                                <div className="setting_ttl_wrapper d-flex align-items-center">
                                    <figure className="sett_back_arrow" >
                                        <Link to={`/testlayer/testinstruction/${id}`}>
                                            <img src={Icons.BackArrow} alt="" className="img-fluid" />
                                        </Link>
                                    </figure>
                                    <div className="sett_ttl">
                                        <h5>Performance Summary</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper">
                                <div className="test_result_report">
                                    <h6>{query1.data ? query1.data.test.title : ''}</h6>
                                    <p className="completion_date">Completed on:<span>{moment(query1?.data?.test ? query1?.data?.test?.progress?.endTime : '').format('DD MMM YYYY')}, at {moment(query1.data.test ? query1.data?.test?.progress?.endTime : '').format('hh:mm a')}</span></p>
                                    <p className="total_marks"><span className="number">{query1?.data?.test ? query1.data?.test?.questions?.length : 0}</span>Questions<span className="dots"></span><span className="number">{query1.data.test ? query1.data?.test?.duration : 0}</span>Minutes</p>
                                </div>
                                <div className="result_report_performance">
                                    <ul type="none" className="result_report d-flex align-items-center flex-wrap">
                                        <li>
                                            <div className="result_percentage d-flex align-items-center">
                                                <figure className="percentage_img">
                                                    <img src={Icons.ResultPerc} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="perc_data">
                                                    <h6>{query1.data.test.progress && ((query1?.data?.test?.progress?.marks / query1?.data?.test?.progress?.totalMarks) * 100) > 0 ? Math.round((query1?.data?.test?.progress?.marks / query1?.data?.test?.progress?.totalMarks) * 100) : 0}%</h6>
                                                    <p>Percentage</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="result_percentage d-flex align-items-center">
                                                <figure className="percentage_img">
                                                    <img src={Icons.ResultAccu} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="perc_data">
                                                    <h6>{query1.data.test && Math.round(query1.data?.test?.progress?.accuracy * 100) < 0 ? 0 : Math.round(query1.data?.test?.progress?.accuracy * 100)}%</h6>
                                                    <p>Accuracy</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="result_percentage d-flex align-items-center">
                                                <figure className="percentage_img">
                                                    <img src={Icons.ResultClock} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="perc_data">
                                                    <h6>{showSpentTime()}</h6>
                                                    <p>Time Spent</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="result_percentage d-flex align-items-center">
                                                <figure className="percentage_img">
                                                    <img src={Icons.ResultMarks} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="perc_data">
                                                    <h6>{query1?.data?.test && (query1?.data?.test?.progress?.marks)}<sub>/{query1?.data?.test && query1?.data?.test?.progress?.totalMarks}</sub></h6>
                                                    <p>Marks</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="result_percentage d-flex align-items-center">
                                                <figure className="percentage_img">
                                                    <img src={Icons.ResultGraph} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="perc_data">
                                                    {
                                                        (new Date(query1.data?.test?.serverTime).getTime() <= new Date(query1?.data?.test?.result).getTime() || (query1.data?.test?.progress?.rank === null && query1.data?.test?.progress?.predictedRank === null)) &&
                                                        <>
                                                            <h6>-/-</h6>
                                                            <p>Result : <span>{moment(query1.data && query1.data.test.result).format('DD MMM')}, at {moment(query1.data && query1.data.test.result).format('hh:mmA')}</span></p>
                                                        </>
                                                    }
                                                    {
                                                        (new Date(query1.data?.test?.serverTime).getTime() > new Date(query1?.data?.test?.result).getTime()) && query1.data?.test?.progress?.predictedRank === null && query1.data?.test?.progress?.rank !== null &&
                                                        <>
                                                            <h6>{query1.data?.test?.progress?.manipulatedRank != null ? query1.data?.test?.progress?.manipulatedRank : query1.data?.test?.progress?.rank}<sub>/{query1.data.test?.resultData?.manipulatedTotalRankers != null ? query1.data.test?.resultData?.manipulatedTotalRankers : query1.data.test?.resultData?.totalRankers}</sub></h6>
                                                            {
                                                                <p>Final Rank</p>

                                                            }
                                                        </>
                                                    }
                                                    {
                                                        (new Date(query1.data?.test?.serverTime).getTime() > new Date(query1?.data?.test?.result).getTime()) && query1.data?.test?.progress?.predictedRank !== null &&
                                                        <>
                                                            <h6>{query1?.data?.test?.progress?.predictedRank}<sub>/{query1?.data?.test?.resultData?.manipulatedTotalRankers != null ? query1?.data?.test?.resultData?.manipulatedTotalRankers : query1?.data?.test?.resultData?.totalRankers}</sub></h6>
                                                            {
                                                                // <p>Predicted Rank</p>
                                                                <p>Final Rank</p>

                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper">
                                <div className="test_result_report test_performance_rating d-flex align-items-center">
                                    <div className="rating_ttl">
                                        {
                                            query1.data && query1.data.test?.progress?.rating === 0 || query1.data.test?.progress?.rating === null &&
                                            <h6>How was your test experience?</h6>
                                        }
                                        {query1.data && query1.data.test?.progress?.rating > 0 &&
                                            <h6>Thank you for your feedback</h6>
                                        }
                                    </div>
                                    {query1.data && query1.data.test?.progress?.rating === 0 || query1.data.test?.progress?.rating === null &&
                                        <div className="star_rating">
                                            <ReactStars {...secondExample} classNames="hello_rate" />
                                        </div>
                                    }
                                    {query1.data && query1.data.test?.progress?.rating > 0 &&
                                        <div className="star_rating">
                                            <ReactStars {...firstExample} classNames="hello_rate" />
                                        </div>
                                    }
                                </div>
                            </div>
                            {
                                config && config?.banner_config?.test?.map(obj => {
                                    if (exist !== true) {
                                        if (obj.percentage > testPerformanceTest(query1.data.test && query1.data.test.progress) <= obj.percentage) {
                                            exist = true
                                            return (<div className="banner_img"><img src={obj.image} alt="img" className="img-fluid" /></div>)

                                        }
                                    }
                                })
                            }
                            <div className="recommended_video_wrapper">
                                <div className="test_result_report result_analysis">
                                    <h6>Result Analysis <span className="question_count">{query1.data.test ? query1.data.test.questions.length : 0} <span className="count_txt">Questions</span></span></h6>
                                </div>
                                <div className="analysis_performance">
                                    <ul type="none" className="analysis_report d-flex align-items-center flex-wrap">
                                        {
                                            (query1.data.test && query1?.data?.test?.isShowingSolution === true) &&
                                            (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) > 0 &&
                                            <li>
                                                <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                    index: null,
                                                    text: "attempt",
                                                    currentPageUrl: currentPageUrl
                                                })}>
                                                    <div className="result_percentage">
                                                        <figure className="percentage_img">
                                                            <Pie data={Piedata} options={pieoptions} />
                                                        </figure>
                                                        <div className="perc_data">
                                                            <h6>{query1.data.test.progress ? query1.data.test.progress.attemptedQuesCount : 0}</h6>
                                                            <p>Attempted</p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </li>
                                        }
                                        {
                                            ((query1.data.test && query1?.data?.test?.isShowingSolution !== true) || (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) < 0) &&
                                            <li>
                                                <div className="result_percentage">
                                                    <figure className="percentage_img">
                                                        <Pie data={Piedata} options={pieoptions} />
                                                    </figure>
                                                    <div className="perc_data">
                                                        <h6>{query1.data.test.progress ? query1.data.test.progress.attemptedQuesCount : 0}</h6>
                                                        <p>Attempted</p>
                                                    </div>
                                                </div>
                                            </li>
                                        }
                                        {
                                            (query1.data.test && query1?.data?.test?.isShowingSolution === true) &&
                                            (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) > 0 &&
                                            <li>
                                                <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                    index: null,
                                                    text: "correct"
                                                })}>
                                                    <div className="result_percentage">
                                                        <figure className="percentage_img">
                                                            <Pie data={correctData} options={pieoptions} />
                                                        </figure>
                                                        <div className="perc_data">
                                                            <h6>{query1.data.test.progress ? query1.data.test.progress.correctQuestions : 0}</h6>
                                                            <p>Correct</p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </li>
                                        }
                                        {
                                            ((query1.data.test && query1?.data?.test?.isShowingSolution !== true) || (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) < 0) &&
                                            <li>
                                                <div className="result_percentage">
                                                    <figure className="percentage_img">
                                                        <Pie data={correctData} options={pieoptions} />
                                                    </figure>
                                                    <div className="perc_data">
                                                        <h6>{query1.data.test.progress ? query1.data.test.progress.correctQuestions : 0}</h6>
                                                        <p>Correct</p>
                                                    </div>
                                                </div>
                                            </li>
                                        }
                                        {
                                            (query1.data.test && query1?.data?.test?.isShowingSolution === true) &&
                                            (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) > 0 &&
                                            <li>
                                                <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                    index: null,
                                                    text: "incorrect"
                                                })}>
                                                    <div className="result_percentage">
                                                        <figure className="percentage_img">
                                                            <Pie data={incorrectData} options={pieoptions} />
                                                        </figure>
                                                        <div className="perc_data">
                                                            <h6>{query1.data.test.progress ? query1.data.test.progress.incorrectQuestions : 0}</h6>
                                                            <p>Incorrect</p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </li>
                                        }
                                        {
                                            ((query1.data.test && query1?.data?.test?.isShowingSolution !== true) || (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) < 0) &&
                                            <li>
                                                <div className="result_percentage">
                                                    <figure className="percentage_img">
                                                        <Pie data={incorrectData} options={pieoptions} />
                                                    </figure>
                                                    <div className="perc_data">
                                                        <h6>{query1.data.test.progress ? query1.data.test.progress.incorrectQuestions : 0}</h6>
                                                        <p>Incorrect</p>
                                                    </div>
                                                </div>
                                            </li>
                                        }
                                        {
                                            (query1.data.test && query1?.data?.test?.isShowingSolution === true) &&
                                            (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) > 0 &&
                                            <li>
                                                <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                    index: null,
                                                    text: "skip"
                                                })}>
                                                    <div className="result_percentage">
                                                        <figure className="percentage_img">
                                                            <Pie data={unansweredData} options={pieoptions} />
                                                        </figure>
                                                        <div className="perc_data">
                                                            <h6>{query1.data.test.progress ? query1.data.test.progress.unattemptedQids.length : 0}</h6>
                                                            <p>Unanswered</p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </li>
                                        }
                                        {
                                            ((query1.data.test && query1?.data?.test?.isShowingSolution !== true) || (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) < 0) &&
                                            <li>
                                                <div className="result_percentage">
                                                    <figure className="percentage_img">
                                                        <Pie data={unansweredData} options={pieoptions} />
                                                    </figure>
                                                    <div className="perc_data">
                                                        <h6>{query1.data.test.progress ? query1.data.test.progress.unattemptedQids.length : 0}</h6>
                                                        <p>Unanswered</p>
                                                    </div>
                                                </div>
                                            </li>
                                        }
                                        {
                                            (query1.data.test && query1?.data?.test?.isShowingSolution === true) &&
                                            (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) > 0 &&
                                            <li>
                                                <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                    index: null,
                                                    text: "guess"
                                                })}>
                                                    <div className="result_percentage">
                                                        <figure className="percentage_img">
                                                            <Pie data={guessData} options={pieoptions} />
                                                        </figure>
                                                        <div className="perc_data">
                                                            <h6>{query1.data.test.progress ? query1.data.test.progress.guessedCount : 0}</h6>
                                                            <p>Guessed</p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </li>
                                        }
                                        {
                                            ((query1.data.test && query1?.data?.test?.isShowingSolution !== true) || (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) < 0) &&
                                            <li>
                                                <div className="result_percentage">
                                                    <figure className="percentage_img">
                                                        <Pie data={guessData} options={pieoptions} />
                                                    </figure>
                                                    <div className="perc_data">
                                                        <h6>{query1.data.test.progress ? query1.data.test.progress.guessedCount : 0}</h6>
                                                        <p>Guessed</p>
                                                    </div>
                                                </div>
                                            </li>
                                        }
                                        {
                                            (query1.data.test && query1?.data?.test?.isShowingSolution === true) &&
                                            (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) > 0 &&
                                            <li>
                                                <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                    index: null,
                                                    text: "review"
                                                })}>
                                                    <div className="result_percentage">
                                                        <figure className="percentage_img">
                                                            <Pie data={reviewedData} options={pieoptions} />
                                                        </figure>
                                                        <div className="perc_data">
                                                            <h6>{query1.data.test.progress ? query1.data.test.progress.reviewedCount : 0}</h6>
                                                            <p>Reviewed</p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </li>

                                        }
                                        {
                                            ((query1.data.test && query1?.data?.test?.isShowingSolution !== true) || (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) < 0) &&
                                            <li>
                                                <div className="result_percentage">
                                                    <figure className="percentage_img">
                                                        <Pie data={reviewedData} options={pieoptions} />
                                                    </figure>
                                                    <div className="perc_data">
                                                        <h6>{query1.data.test.progress ? query1.data.test.progress.reviewedCount : 0}</h6>
                                                        <p>Reviewed</p>
                                                    </div>
                                                </div>
                                            </li>
                                        }
                                    </ul>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper">
                                <div className="test_result_report performance_analysis_ttl d-flex align-items-center">
                                    <div className="performance_ttl">
                                        <h6>Performance Analysis</h6>
                                    </div>
                                    <div className="vw_rankers">
                                        {(query1?.data?.test && query1?.data?.test?.resultData && (query3.data && query3?.data?.getRanks?.results?.length > 0)) &&
                                            <span onClick={showRanker}>View Rankers</span>
                                        }
                                    </div>
                                </div>
                                <div className="analysis_performance">
                                    <div className="performance_tags">
                                        <span className={status === 'mark' ? 'active' : ''} onClick={() => { graphData(query1.data.test && (query1?.data && query1?.data?.test?.progress?.marks) > 0 ? (query1?.data?.test?.progress?.marks) : 0, query1.data?.test?.resultData && (query1.data?.test?.resultData?.avgMarks) > 0 ? (query1.data.test.resultData.avgMarks) : 0, query1.data.test.resultData && (query1.data.test.resultData.topperMarks) > 0 ? (query1.data.test.resultData.topperMarks) : 0, 'mark') }}>Marks</span>
                                        <span className={status === 'accuracy' ? 'active' : ''} onClick={() => { graphData(query1.data.test && (query1.data && query1?.data?.test?.progress?.accuracy * 100) > 0 ? (query1.data?.test?.progress?.accuracy * 100) : 0, query1.data?.test?.resultData && (query1.data?.test?.resultData?.avgAccuracy * 100) > 0 ? (query1.data.test.resultData.avgAccuracy * 100) : 0, query1.data.test.resultData && (query1.data.test.resultData.topperAccuracy * 100) > 0 ? (query1.data.test.resultData.topperAccuracy * 100) : 0, 'accuracy') }}>Accuracy</span>
                                        <span className={status === 'percentage' ? 'active' : ''} onClick={() => { graphData(query1.data.test && (query1.data && query1?.data?.test?.progress?.marks / (query1.data?.test?.progress?.totalMarks) * 100), query1.data.test.resultData && (query1.data.test.resultData.avgMarks / (query1.data.test.progress.totalMarks) * 100), query1.data.test.resultData && (query1.data.test.resultData.topperMarks / (query1.data.test.progress.totalMarks) * 100), 'percentage') }}>Percentage</span>
                                    </div>
                                    <div className="bar_graph">
                                        <Bar options={options} data={data} />
                                    </div>
                                </div>
                            </div>
                            {
                                subjectExist !== true &&
                                <>
                                    <div className="recommended_video_wrapper">
                                        <div className="test_result_report subject_analysis_ttl">
                                            <h6>Subject Analysis</h6>
                                        </div>
                                        <div className="subject_analysis_wrapper">
                                            <div id='accordion'>
                                                {
                                                    query1.data && query1?.data?.test?.progress?.subjectStats.map((d, i) => (
                                                        <div class="subject_analysis_card">
                                                            <div class="subanaysis_header">
                                                                <a class="card-link" data-toggle="collapse" href={`#collapse${i}`}>
                                                                    <div className="subject_analysis d-flex align-items-center">
                                                                        <figure className="sanalysis_img">
                                                                            <img src={d.subject ? d.subject.icon : Icons.Anatomy} alt="" className="img-fluid" />
                                                                        </figure>
                                                                        <div className="sanalysis_text">
                                                                            <h6>{d.subject && d.subject.subjectName} <span>({(d.attemptedQids + d.unattemptedQids)} Questions)</span></h6>
                                                                        </div>
                                                                    </div>
                                                                    <span className="sub_arrow">
                                                                        <img src={Icons.BookmarkArrow} alt="" className="img-fluid" />
                                                                    </span>
                                                                </a>
                                                            </div>
                                                            <div id={`collapse${i}`} class={`${open == i ? 'collapse show' : 'collapse'}`} data-parent={`#accordion`}>
                                                                <div className="subanalysis_performance">
                                                                    <ul type="none" className="analysis_report d-flex align-items-center flex-wrap">
                                                                        {
                                                                            (query1.data.test && query1?.data?.test?.isShowingSolution === true) &&
                                                                            (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) > 0 &&
                                                                            <li>
                                                                                {
                                                                                    topicExist !== true &&
                                                                                    <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                                                        index: i,
                                                                                        text: "attempt"
                                                                                    })}>
                                                                                        <div className="result_percentage">
                                                                                            <h6>{d.attemptedQids}</h6>
                                                                                            <p>Attempted</p>
                                                                                        </div>
                                                                                    </Link>
                                                                                }
                                                                                {
                                                                                    topicExist === true &&
                                                                                    <div className="result_percentage">
                                                                                        <h6>{d.attemptedQids}</h6>
                                                                                        <p>Attempted</p>
                                                                                    </div>
                                                                                }
                                                                            </li>
                                                                        }
                                                                        {
                                                                            ((query1.data.test && query1?.data?.test?.isShowingSolution !== true) || (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) < 0) &&
                                                                            <li>
                                                                                <div className="result_percentage">
                                                                                    <h6>{d.attemptedQids}</h6>
                                                                                    <p>Attempted</p>
                                                                                </div>
                                                                            </li>
                                                                        }
                                                                        {
                                                                            (query1.data.test && query1?.data?.test?.isShowingSolution === true) &&
                                                                            (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) > 0 &&
                                                                            <li className="">
                                                                                {

                                                                                    topicExist !== true &&
                                                                                    <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                                                        index: i,
                                                                                        text: "correct"
                                                                                    })}>
                                                                                        <div className="result_percentage correct">
                                                                                            <h6>{d.correctQids}</h6>
                                                                                            <p>Correct</p>
                                                                                        </div>
                                                                                    </Link>
                                                                                }
                                                                                {topicExist === true &&
                                                                                    <div className="result_percentage correct">
                                                                                        <h6>{d.correctQids}</h6>
                                                                                        <p>Correct</p>
                                                                                    </div>
                                                                                }
                                                                            </li>
                                                                        }
                                                                        {
                                                                            ((query1.data.test && query1?.data?.test?.isShowingSolution !== true) || (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) < 0) &&
                                                                            <li className="">
                                                                                <div className="result_percentage correct">
                                                                                    <h6>{d.correctQids}</h6>
                                                                                    <p>Correct</p>
                                                                                </div>
                                                                            </li>
                                                                        }
                                                                        {
                                                                            (query1.data.test && query1?.data?.test?.isShowingSolution === true) &&
                                                                            (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) > 0 &&
                                                                            <li className="">
                                                                                {
                                                                                    topicExist !== true &&
                                                                                    <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                                                        index: i,
                                                                                        text: "incorrect"
                                                                                    })}>
                                                                                        <div className="result_percentage incorrect">
                                                                                            <h6>{d.incorrectQids}</h6>
                                                                                            <p>Incorrect</p>
                                                                                        </div>
                                                                                    </Link>
                                                                                }
                                                                                {
                                                                                    topicExist === true &&
                                                                                    <div className="result_percentage incorrect">
                                                                                        <h6>{d.incorrectQids}</h6>
                                                                                        <p>Incorrect</p>
                                                                                    </div>
                                                                                }
                                                                            </li>
                                                                        }
                                                                        {
                                                                            ((query1.data.test && query1?.data?.test?.isShowingSolution !== true) || (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) < 0) &&
                                                                            <li className="">
                                                                                <div className="result_percentage incorrect">
                                                                                    <h6>{d.incorrectQids}</h6>
                                                                                    <p>Incorrect</p>
                                                                                </div>
                                                                            </li>
                                                                        }
                                                                        {
                                                                            (query1.data.test && query1?.data?.test?.isShowingSolution === true) &&
                                                                            (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) > 0 &&
                                                                            <li className="">
                                                                                {
                                                                                    topicExist !== true &&
                                                                                    <Link to={`/testlayer/viewallsolution/${id}`} state={JSON.stringify({
                                                                                        index: i,
                                                                                        text: "skip"
                                                                                    })}>
                                                                                        <div className="result_percentage unanswered">
                                                                                            <h6>{d.unattemptedQids}</h6>
                                                                                            <p>Unanswered</p>
                                                                                        </div>
                                                                                    </Link>
                                                                                }
                                                                                {
                                                                                    topicExist === true &&
                                                                                    <div className="result_percentage unanswered">
                                                                                        <h6>{d.unattemptedQids}</h6>
                                                                                        <p>Unanswered</p>
                                                                                    </div>
                                                                                }
                                                                            </li>
                                                                        }
                                                                        {
                                                                            ((query1.data.test && query1?.data?.test?.isShowingSolution !== true) || (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) < 0) &&
                                                                            <li className="">
                                                                                <div className="result_percentage unanswered">
                                                                                    <h6>{d.unattemptedQids}</h6>
                                                                                    <p>Unanswered</p>
                                                                                </div>
                                                                            </li>
                                                                        }
                                                                    </ul>
                                                                    {
                                                                        !d?.topics?.some(item => item.topicId === null) ?

                                                                            <>
                                                                                <Link to={`/testlayer/testTopicAnalysis/${id}`} state={JSON.stringify(d)} >
                                                                                    <a href="#" className="topic_text">
                                                                                        Check Topic Wise Analysis <img src={Icons.SubjectArrow} alt="" className="img-fluid" />
                                                                                    </a>
                                                                                </Link>
                                                                            </>

                                                                            : ''
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            {/* <div class="subject_analysis_card">
                                            <div class="subanaysis_header">
                                                <a class="card-link" data-toggle="collapse" href="#collapseTwo">
                                                    <div className="subject_analysis d-flex align-items-center">
                                                        <figure className="sanalysis_img">
                                                            <img src={Icons.Anatomy} alt="" className="img-fluid"/>
                                                        </figure>
                                                        <div className="sanalysis_text">
                                                            <h6>Physiology <span>(6 Questions)</span></h6>
                                                        </div>
                                                    </div>
                                                    <span className="sub_arrow">
                                                        <img src={Icons.BookmarkArrow} alt="" className="img-fluid"/>
                                                    </span>
                                                </a>
                                            </div>
                                            <div id="collapseTwo" class="collapse" data-parent="#accordion">
                                                <div className="subanalysis_performance">
                                                    <ul type="none" className="analysis_report d-flex align-items-center flex-wrap">
                                                        <li>
                                                            <div className="result_percentage">
                                                                <h6>188</h6>
                                                                <p>Attempted</p>
                                                            </div>
                                                        </li>
                                                        <li className="">
                                                            <div className="result_percentage correct">
                                                                <h6>188</h6>
                                                                <p>Correct</p>
                                                            </div>
                                                        </li>
                                                        <li className="">
                                                            <div className="result_percentage incorrect">
                                                                <h6>188</h6>
                                                                <p>Incorrect</p>
                                                            </div>
                                                        </li>
                                                        <li className="">
                                                            <div className="result_percentage unanswered">
                                                                <h6>188</h6>
                                                                <p>Unanswered</p>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                    <a href="javascript:;" className="topic_text">Check Topic Wise Analysis <img src={Icons.SubjectArrow} alt="" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="subject_analysis_card">
                                            <div class="subanaysis_header">
                                                <a class="card-link" data-toggle="collapse" href="#collapseThree">
                                                    <div className="subject_analysis d-flex align-items-center">
                                                        <figure className="sanalysis_img">
                                                            <img src={Icons.Anatomy} alt="" className="img-fluid"/>
                                                        </figure>
                                                        <div className="sanalysis_text">
                                                            <h6>Physiology <span>(6 Questions)</span></h6>
                                                        </div>
                                                    </div>
                                                    <span className="sub_arrow">
                                                        <img src={Icons.BookmarkArrow} alt="" className="img-fluid"/>
                                                    </span>
                                                </a>
                                            </div>
                                            <div id="collapseThree" class="collapse" data-parent="#accordion">
                                                <div className="subanalysis_performance">
                                                    <ul type="none" className="analysis_report d-flex align-items-center flex-wrap">
                                                        <li>
                                                            <div className="result_percentage">
                                                                <h6>188</h6>
                                                                <p>Attempted</p>
                                                            </div>
                                                        </li>
                                                        <li className="">
                                                            <div className="result_percentage correct">
                                                                <h6>188</h6>
                                                                <p>Correct</p>
                                                            </div>
                                                        </li>
                                                        <li className="">
                                                            <div className="result_percentage incorrect">
                                                                <h6>188</h6>
                                                                <p>Incorrect</p>
                                                            </div>
                                                        </li>
                                                        <li className="">
                                                            <div className="result_percentage unanswered">
                                                                <h6>188</h6>
                                                                <p>Unanswered</p>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                    <a href="javascript:;" className="topic_text">Check Topic Wise Analysis <img src={Icons.SubjectArrow} alt="" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="subject_analysis_card">
                                            <div class="subanaysis_header">
                                                <a class="card-link" data-toggle="collapse" href="#collapseFour">
                                                    <div className="subject_analysis d-flex align-items-center">
                                                        <figure className="sanalysis_img">
                                                            <img src={Icons.Anatomy} alt="" className="img-fluid"/>
                                                        </figure>
                                                        <div className="sanalysis_text">
                                                            <h6>Physiology <span>(6 Questions)</span></h6>
                                                        </div>
                                                    </div>
                                                    <span className="sub_arrow">
                                                        <img src={Icons.BookmarkArrow} alt="" className="img-fluid"/>
                                                    </span>
                                                </a>
                                            </div>
                                            <div id="collapseFour" class="collapse" data-parent="#accordion">
                                                <div className="subanalysis_performance">
                                                    <ul type="none" className="analysis_report d-flex align-items-center flex-wrap">
                                                        <li>
                                                            <div className="result_percentage">
                                                                <h6>188</h6>
                                                                <p>Attempted</p>
                                                            </div>
                                                        </li>
                                                        <li className="">
                                                            <div className="result_percentage correct">
                                                                <h6>188</h6>
                                                                <p>Correct</p>
                                                            </div>
                                                        </li>
                                                        <li className="">
                                                            <div className="result_percentage incorrect">
                                                                <h6>188</h6>
                                                                <p>Incorrect</p>
                                                            </div>
                                                        </li>
                                                        <li className="">
                                                            <div className="result_percentage unanswered">
                                                                <h6>188</h6>
                                                                <p>Unanswered</p>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                    <a href="javascript:;" className="topic_text">Check Topic Wise Analysis <img src={Icons.SubjectArrow} alt="" className="img-fluid"/></a>
                                                </div>
                                            </div>
                                        </div> */}
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                (query1.data.test && query1?.data?.test?.isShowingSolution === true) &&
                                <>
                                    {
                                        (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) > 0 &&
                                        <div className="view_slution_btn text-center">
                                            <Link to={`/testlayer/viewallsolution/${id}`}>
                                                <button type="button" className="btn btn_theme">View Solution</button>
                                            </Link>
                                        </div>
                                    }
                                    {
                                        (new Date(query1.data?.test?.serverTime) - new Date(query1?.data?.test?.solutionTime)) < 0 &&
                                        <div className="attempt_btn lock_attempt text-center">
                                            <p>*You can view solution after {moment(query1.data && query1.data.test.solutionTime).format('DD MMM YYYY')} ,  {moment(query1.data && query1.data.test.solutionTime).format('hh:mm A')}</p>
                                            <button type="button" className="btn btn_theme">
                                                {/* <img src={Icons.Arrowfade} alt="Arrow fade" className="img-fluid" /> */}
                                                View Solution</button>
                                        </div>

                                    }
                                </>

                            }
                        </div>
                    </div>
                </section>
            </div >
            <Modal
                show={rating}
                onHide={hideRating}
                backdrop="static"
                className="detail_modal modal_rating"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h4>Rating</h4>
                        <span className="cross_icon">
                            <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={hideRating} />
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="rating_modal_body">
                        <div className="modal_rating">
                            <ReactStars {...secondExample} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="">Please share your feedback</label>
                            <textarea name="" id="" rows="5" className="form-control" placeholder="Enter feedback" onChange={(e) => handleInputChange(e.target.value, 'feedback')} value={getDetails.feedback ?? ''}></textarea>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme btn_border" onClick={hideRating}>Cancel</button>
                        <button type="button" className="btn btn_theme" onClick={(e) => submitBookmark(e)}>Submit</button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal
                show={ranker}
                onHide={hideRanker}
                backdrop="static"
                className="detail_modal ranker_modal"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h4>Top 30 Rankers</h4>
                        <span className="cross_icon">
                            <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={hideRanker} />
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        query3.data && query3?.data?.getRanks?.results?.length === 0 && <NoDataFound />
                    }
                    {
                        query3.data && query3?.data?.getRanks?.results?.length !== 0 &&
                        <div className="ranker_wrapper">
                            <ul type="none">
                                {
                                    query3.data && query3.data?.getRanks?.results.map((d, i) => (
                                        <li>
                                            <div className="ranker_main d-flex align-items-center">
                                                <figure className="ranker_img">
                                                    <img src={d?.user?.avatar ? d?.user?.avatar : Icons.UserPic} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="ranker_data">
                                                    <h6>{d?.user?.name}</h6>
                                                    <div className="rank_marks d-flex flex-wrap">
                                                        <p>Marks: <span>{d?.marks}</span></p>
                                                        <p>Unanswered: <span>{d?.unattemptedQids?.length}</span></p>
                                                    </div>
                                                    <div className="rank_marks d-flex flex-wrap">
                                                        <p>Correct: <span>{rankersCorrectData(d?.questions)}</span></p>
                                                        <p>Incorrect: <span>{rankersIncorrectData(d?.questions)}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                d.rank === 1 &&
                                                <span className="medal_img">
                                                    <img src={Images.Gold} alt="Gold" className="img-fluid" />
                                                </span>
                                            }
                                            {
                                                d.rank === 2 &&
                                                <span className="medal_img">
                                                    <img src={Images.Silver} alt="Gold" className="img-fluid" />
                                                </span>
                                            }
                                            {
                                                d.rank === 3 &&
                                                <span className="medal_img">
                                                    <img src={Images.Bronze} alt="Gold" className="img-fluid" />
                                                </span>
                                            }
                                            {
                                                d.rank > 3 &&
                                                <span className="medal_img">{d.rank}</span>
                                            }
                                        </li>
                                    ))
                                }
                                {/* <li>
                                    <div className="ranker_main d-flex align-items-center">
                                        <figure className="ranker_img">
                                            <img src={Images.FreeVideoImg} alt="" className="img-fluid"/>
                                        </figure>
                                        <div className="ranker_data">
                                            <h6>Anonymous</h6>
                                            <div className="rank_marks d-flex flex-wrap">
                                                <p>Marks: <span>300</span></p>
                                                <p>Unanswered: <span>300</span></p>
                                            </div>
                                            <div className="rank_marks d-flex flex-wrap">
                                                <p>Correct: <span>300</span></p>
                                                <p>Incorrect: <span>300</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <span className="medal_img">
                                        <img src={Images.Silver} alt="Silver" className="img-fluid"/>
                                    </span>
                                </li> */}
                            </ul>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}